<!-- @format -->

@if (dropdownValues$ | async; as dropdownValues) {
	@if (selectedValue$ | async; as selectedValue) {
		<select
			id="sort-list"
			class="sort-select hmf-py-lg-xxs hmf-pl-lg-0 hmf-pr-lg-m"
			[ngClass]="[sortPositionChangeEnabled() ? 'no-outline hmf-header-xs hmf-pl-xxs hmf-pr-xs hmf-py-xs' : 'show-outline hmf-header-xs hmf-p-xs']"
			title="Select sort option"
			[value]="selectedValue.value"
			[disabled]="isDisabled"
			(change)="selectValue($event.target)"
			(keydown.tab)="onTabKeyDown()">
			@for (option of dropdownValues; track option.value) {
				<option
					[value]="option.value"
					[attr.selected]="option.value === selectedValue.value || null">
					{{ option.label }}
				</option>
			}
		</select>
	}
	@if (sortPositionChangeEnabled()) {
		<homefield-icon
			class="sort-select-arrow hmf-position-absolute"
			name="chevron-down"
			width="16px"
			height="16px">
		</homefield-icon>
	} @else {
		<homefield-icon
			class="sort-select-arrow hmf-position-absolute hmf-pr-xxxs"
			name="chevron-down"
			width="16px"
			height="16px">
		</homefield-icon>
	}
}
